import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { useUserStore } from 'src/stores/useUserStore'
import { echoConnectionOptions } from 'src/utils/echoConfig'

declare global {
  interface Window {
    Pusher: typeof Pusher
  }
}

window.Pusher = Pusher

export let echoSocket: Echo<'pusher'> | null = null

export const getSocket = () => {
  const userStore = useUserStore()
  if (!userStore.token) {
    return null
  }

  if (!echoSocket && userStore.token) {
    echoSocket = new Echo({
      ...echoConnectionOptions(),

      channelAuthorization: {
        endpoint: '/api/broadcasting/auth',
        headers: { Authorization: `Bearer ${userStore.token}` },
      },
    })

    // Log when socket is connected
    echoSocket.connector.pusher.connection.bind('connected', () => {
      
    })

    // Log when socket is disconnected
    echoSocket.connector.pusher.connection.bind('disconnected', () => {
      
    })

    // Log any errors
    echoSocket.connector.pusher.connection.bind('error', (error: Error) => {
      console.error('WebSocket error:', error)
    })
  }
  return echoSocket
}
